import React from 'react';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';
import { Operation } from '../../hooks/useOperations/types';
import { importFromS3 } from '../../utils/importFromS3';

interface InSeasonPluginContainerProps {
  operations: Operation[];
  operationsSelected: string[];
}

// Runtime dependency
const InSeasonPlugin: React.FC<InSeasonPluginContainerProps> = React.lazy(() =>
  importFromS3('tcc-in-season-web'),
);

export const InSeasonPluginContainer: React.FC<InSeasonPluginContainerProps> = ({
  operations,
  operationsSelected,
}) => {
  const { operation: impersonatedOperation } = useImpersonatedOperation();

  const operationIds = impersonatedOperation
    ? [impersonatedOperation.operationId]
    : operationsSelected;

  return (
    <InSeasonPlugin operations={operations} operationsSelected={operationIds} />
  );
};
